import { FC } from 'react';
import { Box, BoxProps, Tab, Tabs, TabsProps } from '@mui/material';

import { SectionHeading } from '../../../../../components/SectionHeading';
import Printable from '../../../../../components/Printable';

const PAGE_TABS = {
    CAMPAIGN_AD_GROUP_OVERVIEW: 0,
    CAMPAIGN_AD_GROUP_FLIGHTS: 1,
    CAMPAIGN_AD_GROUP_TARGETING: 2,
    CAMPAIGN_AD_GROUP_CREATIVES: 3,
};

type CampaignPageTabsProps = {
    slotProps?: {
        box?: BoxProps;
    };
} & TabsProps;

const CampaignPageTabs: FC<CampaignPageTabsProps> = ({ slotProps = {}, ...props }): React.JSX.Element => {
    const tab: number = props.value;

    return (
        <Box
            sx={{
                mt: (theme) => theme.spacing(2),
            }}
            {...slotProps?.box}
        >
            <Printable show={false}>
                <Tabs {...props}>
                    <Tab value={PAGE_TABS.CAMPAIGN_AD_GROUP_OVERVIEW} label="Ad Group Info" />
                    <Tab value={PAGE_TABS.CAMPAIGN_AD_GROUP_FLIGHTS} label={'Flights'} />
                    <Tab value={PAGE_TABS.CAMPAIGN_AD_GROUP_TARGETING} label="Targeting" />
                    <Tab value={PAGE_TABS.CAMPAIGN_AD_GROUP_CREATIVES} label="Creatives" />
                </Tabs>
            </Printable>
            <Printable show={true}>
                <Box sx={{ mb: 2 }}>
                    {tab === PAGE_TABS.CAMPAIGN_AD_GROUP_OVERVIEW && (
                        <SectionHeading divider={false}>Ad Group Info</SectionHeading>
                    )}
                    {tab === PAGE_TABS.CAMPAIGN_AD_GROUP_FLIGHTS && (
                        <SectionHeading divider={false}>Flights</SectionHeading>
                    )}
                    {tab === PAGE_TABS.CAMPAIGN_AD_GROUP_TARGETING && (
                        <SectionHeading divider={false}>Targeting</SectionHeading>
                    )}
                    {tab === PAGE_TABS.CAMPAIGN_AD_GROUP_CREATIVES && (
                        <SectionHeading divider={false}>Creatives</SectionHeading>
                    )}
                </Box>
            </Printable>
        </Box>
    );
};

export type { CampaignPageTabsProps };
export { PAGE_TABS };
export default CampaignPageTabs;
